import React from 'react';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import GeneralDialogLayout from '@Containers/Dialogs/GeneralDialogLayout/GeneralDialogLayout';
import { ButtonWithIcon } from '@els/els-react--button';
import { closeDialog } from '@Containers/Dialogs/DialogsActions';
import { typeOfCopyStructureToQueryModal } from './CopyStructureToQueryModalConstants';

import './CopyStructureToQueryModal.scss';

function CopyStructureToQueryModal(props) {
  const { redirectToQuery = () => {} } = props;
  const dispatch = useDispatch();
  return (
    <GeneralDialogLayout
      className="copy-structure-to-query-modal"
      {...props}
      headerClassName="rx-border-none"
      footerClassName="rx-border-none"
      header={
        <div className="copy-structure-to-query-modal-header">
          <h4 className="rx-newmodal-title">Copy structure to query</h4>
        </div>
      }
      footer={
        <div className="copy-structure-to-query-modal-footer">
          <span>
            <ButtonWithIcon
              data-e2e="copy-to-query-cancel"
              type="tertiary"
              size="small"
              sprite="Close"
              linkIconSize="s"
              iconRight
              aria-label="Cancel"
              tabIndex="0"
              onClick={() => {
                dispatch(
                  closeDialog({
                    id: typeOfCopyStructureToQueryModal,
                  })
                );
              }}
              className="u-els-margin-left e2e-copy-to-query-cancel">
              Cancel
            </ButtonWithIcon>
            <ButtonWithIcon
              data-e2e="copy-to-query-confirm"
              type="primary"
              size="small"
              sprite="ChevronRight"
              linkIconSize="s"
              iconRight
              aria-label="Copy to query"
              tabIndex="0"
              onClick={() => {
                redirectToQuery();
                dispatch(
                  closeDialog({
                    id: typeOfCopyStructureToQueryModal,
                  })
                );
              }}
              className="u-els-margin-left e2e-copy-to-query-save">
              Copy to query
            </ButtonWithIcon>
          </span>
        </div>
      }>
      <div className="copy-structure-to-query__content">
        <div className="copy-structure-to-query__content_text u-els-font-size-h5">
          <div>Are you sure you want to overwrite your current structure search?</div>
        </div>
      </div>
    </GeneralDialogLayout>
  );
}

CopyStructureToQueryModal.propTypes = {
  redirectToQuery: PropTypes.func,
};

export default CopyStructureToQueryModal;
